<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-slot:app-bar-btn>
				<v-btn
					v-if="authority_flag && $vuetify.breakpoint.smAndUp"
					color="white"
					text
					@click="$router.push({ name: 'check_sheet_template_new' })"
				>
					<v-icon class="mr-1">mdi-clipboard-list-outline</v-icon>
					新規テンプレート作成
				</v-btn>
			</template>
			<v-row no-gutters justify="end">
				<v-btn
					class="mt-4"
					v-if="authority_flag && $vuetify.breakpoint.xs"
					color="secondary"
					text
					@click="$router.push({ name: 'check_sheet_template_new' })"
				>
					<v-icon class="mr-1">mdi-clipboard-list-outline</v-icon>
					新規テンプレート作成
				</v-btn>
			</v-row>
			<CheckSheetTemplateSearchSection
				:query="q"
				@search-check-sheet-templates="searchCheckSheetTemplates($event)"
			/>
			<v-divider class="mt-4" />
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="check_sheet_templates"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr
							@click="$router.push({ name: 'check_sheet_template_show', params: { id: item.id } })"
						>
							<td>XXXXXXX</td>
							<td>XXX</td>
							<td>XXXXXXXX</td>
							<td>XXX XXX</td>
							<td>XXXX/XX/XX XX:XX</td>
							<td>XXXX/XX/XX XX:XX</td>
							<!-- <td>{{ item.template_number }}</td>
							<td>{{ item.TODO }}</td>
							<td>{{ item.name }}</td>
							<td>{{ item.user.full_name }}</td>
							<td>{{ common.formatDateTime(item.created_at) }}</td>
							<td>{{ common.formatDateTime(item.updated_at) }}</td> -->
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import CheckSheetTemplateSearchSection from "./components/CheckSheetTemplateSearchSection.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		CheckSheetTemplateSearchSection,
	},
	data() {
		return {
			title: "チェックシートテンプレート一覧",
			check_sheet_templates: [],
			authority_flag: false,
			headers: headers(),
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "created_at desc",
				template_number_cont: null,
				name_cont: null,
			},
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		// this.fetchCheckSheetTemplates(this.q, page, true)
		this.check_sheet_templates = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }]
		this.authority_flag = true
	},
	methods: {
		fetchCheckSheetTemplates(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/check_sheet_templates", {
					params,
					headers,
				})
				.then((res) => {
					this.check_sheet_templates = res.data.check_sheet_templates
					this.pagination = res.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.authority_flag = res.data.authority_flag
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchCheckSheetTemplates(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchCheckSheetTemplates(q) {
			this.q = q
			this.fetchCheckSheetTemplates(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
}

function headers() {
	return [
		{ text: "番号", value: "template_number", width: "150px" },
		{ text: "対象分類", value: "", width: "120px" },
		{ text: "チェックシート名", value: "name", width: "200px" },
		{ text: "最終更新者", value: "user.full_name", width: "120px" },
		{ text: "作成日", value: "created_at", width: "150px" },
		{ text: "最終更新日", value: "updated_at", width: "150px" },
	]
}
</script>
